import { useEffect, useState } from 'react'

/** Instant courant, rafraîchi chaque seconde (comptes à rebours). */
export function useSecondes(): number {
  const [maintenant, setMaintenant] = useState(() => Date.now())
  useEffect(() => {
    const t = setInterval(() => setMaintenant(Date.now()), 1000)
    return () => clearInterval(t)
  }, [])
  return maintenant
}

/** « Expire dans 04:12 », puis « Expiré ». */
export function Decompte({
  jusqua,
  className = 'discret',
}: {
  jusqua: string
  className?: string
}) {
  const maintenant = useSecondes()
  const reste = Math.max(0, Math.floor((new Date(jusqua).getTime() - maintenant) / 1000))
  const mm = String(Math.floor(reste / 60)).padStart(2, '0')
  const ss = String(reste % 60).padStart(2, '0')
  return <span className={className}>{reste > 0 ? `Expire dans ${mm}:${ss}` : 'Expiré'}</span>
}
